module.exports = __webpack_public_path__ + "static/media/DH_05.322b4ae5.jpg";